<template>
	<div class="col-12">
		<div class="card card-outline card-info">
			<div class="card-header">
				<h3 class="card-title">Llenado de evaluación</h3>
			</div>
			<div class="card-body">
				<FillEvaluation :evaluation="evaluation || []"></FillEvaluation>                     				
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

import request from '../../services/request'
import FillEvaluation from '../../component/evaluations/FillEvaluation.vue';

export default {
	props: {
		evaluation: {
		type: Object,
		required: true,
		},
	},
	name: "evaluation-fill",
	components: {
		FillEvaluation
	},
	data() {
		return {
		}
	},
	async mounted() {
		this.setHeaderTitle('Encuesta');
		await this.evaluationsRequest()
	},
	created() {
		Event.$on("event-load-profiles", () => {
			this.list();
		});
	},
	methods: {
		// async list(page = 1) {
		// 	let service = request;
		// 	let search = this.search;
		// 	let _endpoint = '/profiles';
		// 	try {
		// 		let { data } = await service.list(_endpoint, page, search)
		// 		if (data) {
		// 			this.profiles = data;
		// 		}
		// 	} catch (error) {
		// 		console.log(error);
		// 	}
        // },
        async evaluationsRequest() {
			let service = request;
			let _endpoint = '/evaluations';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.evaluations = data;
				}
			} catch (error) {
				console.log(error);
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			errorNotification: 'alert/error',
		})
	}
}
</script>

<style scoped>
.card-body{
	max-height: 500px;
    overflow-y: overlay;
}
</style>
